// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39zVk","fullView":"styles_fullView__3d1oI"};